import React from "react";
import DDJJSubOptionRow from "./DDJJSubOptionRow";

const DDJJSubOptions = ({ formId, option, rowStart, subOptions, hasInput }) => {
    if (!subOptions?.length) {
        return null;
    }

    return subOptions.map((subOption, index) => {
        const row = rowStart + index;
        const className = index === 0 ? "ddjj-suboption-top" : "ddjj-suboption-bottom";

        return (
            <DDJJSubOptionRow
                formId={formId}
                option={option}
                subOption={subOption}
                row={row}
                hasInput={hasInput}
                className={className}
            />
        );
    });
};

export default DDJJSubOptions;
